import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsTreemap from 'highcharts/modules/treemap';
HighchartsTreemap(Highcharts);

const HighChartTreemapChart = (props) => {
    const { chartOptions } = props;

    return (
        <HighchartsReact
            containerProps={{ style: { height: 'auto', width: '100%' } }}
            highcharts={Highcharts}
            options={chartOptions}
        />
    );
};

export default HighChartTreemapChart;
